import { ToWords } from "to-words";

export const formatDate = (date) => {
  if (!date) return null;
  if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
    return date;
  }
  const d = new Date(date);
  if (isNaN(d.getTime())) return null;
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const formatHoursMinutes = (hours) => {
  if (hours == null) return "--";

  const h = Math.floor(hours);
  const m = Math.round((hours - h) * 60);

  return `${h} h ${m} min`;
};

const toWords = new ToWords({
  localeCode: "en-IN",
  converterOptions: {
    currency: true,
    ignoreDecimal: true,
    ignoreZeroCurrency: false,
  },
});

export const amountToWords = (amount) => {
  if (!amount && amount !== 0) return "";
  return toWords.convert(Number(amount));
};
